<app-base-card [cardTitle]="title">
  <div *ngIf="!busy; else loadingState">
    <ng-container *ngIf="!empty; else emptyState">
      <h3 class="!text-5xl bold" *ngIf="displaySubtitle">{{ subtitle }}</h3>
      <p class="!text-lg mt-4 text-gray-500" *ngIf="displayCardText">{{ cardTextPrefix }} <ion-label color="dark">{{ cardText }}</ion-label></p>
    </ng-container>
  </div>
  <ng-template #loadingState>
    <ion-skeleton-text class="!text-5xl" [animated]="true" *ngIf="displaySubtitle"></ion-skeleton-text>
    <ion-skeleton-text class="!text-lg mt-4" [animated]="true" *ngIf="displayCardText"></ion-skeleton-text>
  </ng-template>
  <ng-template #emptyState>
      <ion-label color="dark">{{ 'WALLET.NO_PERF' | transloco }}</ion-label> 
  </ng-template>
</app-base-card>
